<script>
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";

export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      }
    },
    data(){
        return{
            searchHistory: [],
            fields: [
                { key:"date", label: "Date/Heure de Recherche"},
                { key:"customer", label: "Client"},
                { key:"userName", label: "Utilisateur"},
                { key:"type", label: "Type de recherche"},
                { key:"filter", label: "Filtre de Recherche"},
                { key:"brand", label: "Marque"},
                { key:"clientDeviceCode", label: "Poste"},
                { key:"resultsCount", label: "Résultats"}

                ],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            selectedCustomer:null,
            start:this.firstDay,
            end:this.lastDay,
            isGetSearchHistoryStarting:false,
        }
    },
    methods:{
        getSearchHistory(){
            this.isGetSearchHistoryStarting=true
            ReportingApi.getSearchHistory(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                (result) => {
                    if(result){
                        this.searchHistory=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetSearchHistoryStarting=false
            })
        },
        getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        },

        typeToLabel(typeSearch) {
        switch(typeSearch) {
            case 0: return 'vehicule';
            case 1: return 'reference';
            case 2: return 'oem';
            case 3: return 'competitor';
            case 4: return 'vin';
            default: return '';
        }
        },

        typeToColor(typeSearch) {
        switch(typeSearch) {
            case 0: return 'warning';
            case 1: return 'info';
            case 2: return 'success';
            case 3: return 'danger'
            case 4: return 'success'
            default: return 'dark';
        }
        },
        typeToIcons(typeSearch){
            switch(typeSearch) {
            case 0: return 'fas fa-car';
            case 1: return 'fas fa-hashtag';
            case 2: return 'fas fa-registered';
            case 3: return 'fas fa-warehouse'
            case 4: return 'fas fa-atlas'
            default: return 'dark';
        }

        }
    },
    mounted(){
      this.getCustomers()
      this.getSearchHistory()
    },
        watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getSearchHistory()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getSearchHistory()
          }
        },

        selectedCustomer: function(){
            this.getSearchHistory()
        }
    }
}
</script>
<template>
    <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-primary">{{ $t("reporting.supplier.tabHistory.cardTitle") }}</h4>
        <div  class="row mt-4">
            <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12   ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>
        <div class="table-responsive mb-0" style="max-height:31em;min-height:31em"  >
            <b-table
            :busy="isGetSearchHistoryStarting"
            :striped="true"
            :small="true"
            :hover="true"
            :items="searchHistory"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>

            <template v-slot:head(date)>
                {{ $t("reporting.supplier.tabHistory.fields.date") }} 
            </template>
            <template v-slot:head(customer)>
                {{ $t("reporting.supplier.tabHistory.fields.customer") }} 
            </template>
            <template v-slot:head(type)>
                {{ $t("reporting.supplier.tabHistory.fields.type") }} 
            </template>
            <template v-slot:head(filter)>
                {{ $t("reporting.supplier.tabHistory.fields.filter") }} 
            </template>
            <template v-slot:head(brand)>
                {{ $t("reporting.supplier.tabHistory.fields.brand") }} 
            </template>
            <template v-slot:cell(type)="{value}">
                <h5>
                    
                    <b-badge href="#" :variant="typeToColor(value)">
                        <i 
                        class="font-size-14 mr-2" 
                    :class="typeToIcons(value)"
                    > 
                    </i>  {{$t('reporting.supplier.tabHistory.searchTypes.'+typeToLabel(value))}}
                        </b-badge>
                </h5>
            </template>
            <template v-slot:cell(filter)="{value}">
                {{!value ? "_" : value}}
            </template>
            <template v-slot:cell(brand)="{value}">
                {{!value ? "_" : value}}
            </template>

            </b-table>
            <span v-if="!isGetSearchHistoryStarting && !searchHistory.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }}</span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getSearchHistory()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getSearchHistory()" :disabled="isGetSearchHistoryStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
    </div>
</template>